import Timesheet from "../common/Timesheet";

const ManagerTimesheet = () => <Timesheet />;

export default ManagerTimesheet;
